// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { JiraCard } from './JiraCard';

const jiraCard = EntityCardBlueprint.make({
  name: 'jira',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { JiraCard } = await import('./JiraCard');
      return <JiraCard />;
    },
  },
});

export const jiraCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [jiraCard],
});
